import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNearbyLocation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 24,
	viewBox: "0 0 26 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_9117_225743)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M12.948 5.66211C10.9112 5.66235 8.89307 6.47043 9.10523 8.08515L9.62523 11.5949C9.71649 12.2124 10.1686 13.2 10.8438 13.2H10.8919L11.445 19.0875C11.4689 19.3524 11.6769 19.5675 11.965 19.5675H14.045C14.333 19.5675 14.541 19.3524 14.565 19.0875L15.118 13.2H15.1663C15.8416 13.2 16.2934 12.2124 16.385 11.5949L16.905 8.08515C17.0412 6.46899 14.9851 5.66163 12.948 5.66211Z",
					fill: "#757575"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.0042 12.2188L12.9922 12.249C12.9962 12.2399 12.9989 12.2305 13.0029 12.2214L13.0042 12.2188Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.9995 5.04C14.5073 5.04 15.7295 3.91176 15.7295 2.52C15.7295 1.12824 14.5073 0 12.9995 0C11.4918 0 10.2695 1.12824 10.2695 2.52C10.2695 3.91176 11.4918 5.04 12.9995 5.04Z",
					fill: "#757575"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.5 16.6035C16.4779 16.8368 16.4545 17.0696 16.4324 17.3029C18.7599 17.6062 19.825 18.2737 20.02 19.1252C20.3104 20.3914 15.8231 20.9612 12.9324 20.9345C10.0417 20.9077 5.63706 20.3914 6.02212 19.1249C6.27484 18.2938 7.15445 17.6195 9.42113 17.3054C9.39851 17.0714 9.37277 16.8374 9.35093 16.6036C6.43738 16.9002 4.8308 17.6302 3.861 18.5823H0.57954L0 19.6918H3.42316C3.68914 20.9974 6.65418 22.1245 10.894 22.4091L10.7489 24.0005H14.9453L14.9032 22.4093C19.1646 22.1245 22.2136 20.9974 22.5768 19.6918H26L25.5034 18.5823H22.2219C21.3008 17.6062 19.4897 16.8848 16.5 16.6035Z",
					fill: "#757575"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_9117_225743",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 26,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgNearbyLocation);
export { ForwardRef as ReactComponent };
